import { VehicleType } from "../../DataStructures/Vehicle/VehicleType";
import { Trip } from "../../DataStructures/Trip/Trip";
import { TypeRatio } from "./TypeRatio";
import { Vehicle } from "../../DataStructures/Vehicle/Vehicle";
import { VehicleReservation } from "../../DataStructures/VehicleReservation/VehicleReservation";

export class Suggestion{

    
    TypeRatio:TypeRatio;
    vehicleReservation:VehicleReservation;
    trip:Trip;

    constructor(trip:Trip,typeRatio:TypeRatio){
        this.trip = trip;
        this.TypeRatio = typeRatio;
    }
}